import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { Data, Variables } from './types'

export const GET_WORKSPACE_BIDDER: TypedDocumentNode<Data, Variables> = gql`
  query getWorkspaceBidder($id: ID!) {
    node(id: $id) {
      ... on WorkspaceBidder {
        accountType
        bidCpmAdjustment
        bidder {
          id
          name
        }
        bidderCode
        bidderConfig
        bidderConfigEnabled
        bidderSid
        consentMode
        enabled
        id
        priority
        status
        supplyChain {
          id
        }
      }
    }
  }
`
